import React, { useContext } from "react";
import {
  Caption,
  Card,
  Collapsible,
  ColorPicker,
  Layout,
  Stack,
  TextField,
  TextStyle,
  TextContainer,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const MenuTab = () => {
  const {
    color,
    errorMessage,
    handleChange,
    hex,
    // learnMore,
    resetDefault,
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { HEX, COLOR, TOAST_TEXT, DEFAULT_TOASTE_TEXT_COLOR } = constant;

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.toastTextColor.title")}
        description={cms("section.toastTextColor.description")}
      >
        <Card
          title={[
            cms("section.toastTextColor.title"),
            updatedAt && (
              <TextStyle variation="subdued">
                <Caption>{`${baseHelper.lastUpdateDate(updatedAt)}`}</Caption>
              </TextStyle>
            ),
          ]}
        >
          <Card.Section>
            <TextContainer>{cms("section.toastTextColor.subDescription")}</TextContainer>

            <br />
            <Stack>
              <Stack.Item fill>
                <TextField
                  label={cms("section.toastTextColor.label.hexCode")}
                  value={hex.toastTextHex}
                  onChange={(value) => handleChange(TOAST_TEXT, value, HEX)}
                  labelAction={
                    hex.toastTextHex !== DEFAULT_TOASTE_TEXT_COLOR && {
                      content: cms("label.reset"),
                      onClick: () => resetDefault(TOAST_TEXT, DEFAULT_TOASTE_TEXT_COLOR, HEX),
                    }
                  }
                  error={errorMessage && errorMessage.toastText}
                />
                <br />
                <TextStyle>
                  <div
                    style={{
                      width: "120px",
                      height: "50px",
                      background: hex.toastBackgroundHex,
                      color: hex.toastTextHex,
                      textAlign: "center",
                      paddingTop: "13px",
                    }}
                  >
                    {cms("section.toastTextColor.label.sampleHeader")}
                  </div>
                </TextStyle>
              </Stack.Item>
              <Stack.Item>
                <ColorPicker
                  onChange={(value) => handleChange(TOAST_TEXT, value, COLOR)}
                  color={color.toastTextColor}
                />
              </Stack.Item>
            </Stack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withErrorBoundary(MenuTab);
